<template>
  <v-container grid-list-md text-xs-center style="padding-top: 30px;">
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
              <v-layout row>
          <v-flex lg12>
          <h4>Please select the category that best describes your issue.</h4>
          </v-flex>
        </v-layout>
      <transition name="component-fade" appear>
        <v-layout row wrap>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Plumbing')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/water.png" style="width:100px">
            <p>Plumbing</p>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Heating')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/heating.png" style="width:100px">
            <p>Heating</p>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Electric')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/electric.png" style="width:100px">
            <p>Electric</p>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Appliances')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/appliances.png" style="width:100px">
            <p>Appliances</p>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Exterior')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/exterior.png" style="width:100px">
            <p>Exterior</p>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark color="primary" class="type" @click.native="typeClicked('Interior')">
          <v-card-text class="px-0">
            <img src="https://d1dwubzia1nkxt.cloudfront.net/interior.png" style="width:100px">
            <p>Interior</p>
            </v-card-text>
        </v-card>
      </v-flex>
       
      </v-layout>
      </transition>
    </v-flex>
    </v-layout>
 </v-container>
</template>

<script>
//  import firebaseApp from '../modules/firebase/firebaseInit'

import { EventBus } from '../event-bus.js'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  name: 'issuerequest',
  data () {
    return {
      step: 0,
      firstName: '',
      lastName: '',
      imageUrl: '',
      image: null,
      uploadTask: '',
      progressUpload: 0,
      showProgress: false,
      downloadURL: ''
    }
  },
  methods: {
    typeClicked (type) {
      EventBus.$emit('type', type)
      // this.$router.push('/issue-type')
      this.$router.push({ name: 'issuerequest', params: { type: type } })
      // this.$router.push({ path: '/issue-type' })
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    font-size: 30px;
    margin: 30px 0;
  }
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
.type {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// IssueType.vue?7597600a